// removed by extract-text-webpack-plugin
module.exports = {"block":"CatalogMain__block-30P2z","sliderItem":"CatalogMain__sliderItem-26mPJ"};